<template>
  <div
      class="order-actions"
      :class="{
        'has-previous': !!labels.previous
      }"
  >
    <div class="order-actions__next">
      <BaseButton
          align="end"
          :color="colorNext"
          link-type="button"
          width="full auto-md"
          @click.prevent="handleNextClick"
      >
        {{ labels.next }}
      </BaseButton>
    </div>
    <div
        v-if="labels.previous"
        class="order-actions__previous"
    >
      <BaseButton
          align="start"
          :color="colorPrevious"
          link-type="button"
          width="full auto-md"
          @click.prevent="handlePreviousClick"
      >
        {{ labels.previous }}
      </BaseButton>
    </div>
    <div
        v-if="!hideRequiredHint"
        class="order-actions__text-required"
    >
      Mit * markierte Felder sind Pflichtfelder.
    </div>
  </div>
</template>

<script setup lang="ts">
withDefaults(defineProps<{
  labels: {
    previous?: string
    next: string
  }
  colorPrevious?: string,
  colorNext?: string,
  hideRequiredHint?: boolean
}>(), {
  colorPrevious: 'dark-outline',
  colorNext: 'red-orange',
});
const emit = defineEmits(['previous', 'next']);

const internetModal = document.getElementsByClassName('priceshow-internet-configuration')[0];

const toTop = () => {
  if (internetModal) {
    internetModal.scrollIntoView({ behavior: 'smooth' });
  }
};

const handleNextClick = () => {
  emit('next');
  if (internetModal) {
    toTop();
  }
};

const handlePreviousClick = () => {
  emit('previous');
  if (internetModal) {
    toTop();
  }
};
</script>

<style lang="scss">
@import 'src/scss/component-helpers';

.order-actions {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;

  @media (min-width: map_get($grid-breakpoints, 'md')) {
    grid-template-columns: 1fr auto;
  }

  .order-actions__text-required {
    text-align: center;

    @media (min-width: map_get($grid-breakpoints, 'md')) {
      grid-column: 1 / 3;
      text-align: start;
    }
  }

  &.has-previous {
    .order-actions__previous {
      order: 2;

      @media (min-width: map_get($grid-breakpoints, 'md')) {
        grid-row: 1 / 2;
        order: 1
      }
    }

    .order-actions__next {
      order: 1;

      @media (min-width: map_get($grid-breakpoints, 'md')) {
        order: 2;
      }
    }

    .order-actions__text-required {
      order: 3;
    }
  }
}
</style>
